import { Pipe, PipeTransform } from '@angular/core';
import { MomentLocalizedDateService } from './moment-localized-date.service';

@Pipe({
  name: 'momentLocalizedDate'
})
export class MomentLocalizedDatePipe implements PipeTransform {
  constructor(private _momentDateService: MomentLocalizedDateService) {
  }

  transform(value: any, args?: any): any {
    return this._momentDateService.format(value, args);
  }
}
